import React from 'react'
import DisplayBrand from '../../components/ViewComponents/displayBrand'
import landingPageStyle from './styles'
function LandingPage() {
  const classes = landingPageStyle()
  return (
    <div className={classes.base}>
      <DisplayBrand />
      <div className={classes.content}></div>
    </div>
  )
}

export default LandingPage
